import React from 'react';
import PropTypes from 'prop-types';

const InputComponent = React.forwardRef(
	({ children, style, ...props }, ref) => (
		<div
			ref={ref}
			{...props}
			style={{
				display: 'flex',
				alignItems: 'center',
				lineHeight: '0.4375em',
				minHeight: 35,
				marginTop: 8,
				...style,
			}}
		>
			{children}
		</div>
	),
);

InputComponent.propTypes = {
	children: PropTypes.any,
	style: PropTypes.object,
};

export default InputComponent;
